import { render } from "./TeacherTemplatesModal.vue?vue&type=template&id=0eccbc9e&scoped=true"
import script from "./TeacherTemplatesModal.vue?vue&type=script&lang=js"
export * from "./TeacherTemplatesModal.vue?vue&type=script&lang=js"

import "./TeacherTemplatesModal.vue?vue&type=style&index=0&id=0eccbc9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eccbc9e"]])

export default __exports__